import React from "react";
import PoliticalLeader from "./Components/PoliticalLeader";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
function App() {
  return (
    <PoliticalLeader/>
  );
}

export default App;
